import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Todo } from './todo';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { animate, animation, AnimationReferenceMetadata, AnimationTriggerMetadata, group, keyframes, query, state, style, transition, trigger, useAnimation } from '@angular/animations';
import { AlphaLinkbarComponent } from '../shared/alpha-linkbar/alpha-linkbar.component';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AdminRequestService } from "src/app/services/admin-request/admin-request.service";
import {  UserRoleType } from '../enums/user-role-type.enum';
import { MsalService } from '@azure/msal-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { User } from '../Models/User';

type StyleType = 'hover' | 'unauthorized' | 'disabled';
const shrink = animation(
  animate('{{time}}', style({ height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' })),
  { params: { time: '1000ms' } },
);
const grow = animation(
  [
    style({ height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' }),
    animate('{{time}}', style({ height: '*', paddingTop: '*', paddingBottom: '*', marginTop: '*', marginBottom: '*' })),
  ],
  { params: { time: '1000ms' } },
);

export function useSwingInAnimation(time: string = '1000ms'): AnimationReferenceMetadata {
  return useAnimation(swingIn, { params: { time } });
}
export const swingIn = animation(
  [
    style({ transformOrigin: '50% 0px', transform: 'perspective(500px) rotate3d(1, 0, 0, 90deg)' }),
    group([
      useAnimation(grow, { params: { time: '1000ms' } }),
      animate('{{time}}',
        keyframes([
          style({ transform: 'perspective(500px) rotate3d(1, 0, 0, -70deg)' }),
          style({ transform: 'perspective(500px) rotate3d(1, 0, 0, 40deg)' }),
          style({ transform: 'perspective(500px) rotate3d(1, 0, 0, -15deg)' }),
          style({ transform: 'perspective(500px) rotate3d(1, 0, 0, 0deg)' }),
        ]),
      ),
    ]),
  ],
  { params: { time: '1000ms' } },
);
export const swingOut = animation(
  [
    animate('{{time}}',
      keyframes([
        style([{ transformOrigin: '50% 0px', transform: 'perspective(500px) rotate3d(1, 0, 0, 0deg)' }, { offset: 0 }]),
        style([{ transform: 'perspective(500px) rotate3d(1, 0, 0, -30deg)' }, { offset: 0.3 }]),
        style([{ transform: 'perspective(500px) rotate3d(1, 0, 0, 90deg)' }, { offset: 1 }]),
      ]),
    ),
    useAnimation(shrink, { params: { time: '1000ms' } }),
  ],
  { params: { time: '1000ms' } },
);
/**
* rotate element out on the X axis until it is facing up and invisible to the user
* @param time the duration of the animation
*/
export function useSwingOutAnimation(time: string = '1000ms'): AnimationReferenceMetadata {
  return useAnimation(swingOut, { params: { time } });
}

export const swingInAndOut = trigger('swingInAndOut', [
  transition(':enter', useAnimation(swingIn)),
  transition(':leave', useAnimation(swingOut)),
]);





@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [
        swingInAndOut
        // animation triggers go here
    ],
    standalone: false
})
export class DashboardComponent implements OnInit {
  mySVG: string;
  adminPermissions: boolean = false; 
  GBSBillingPermissions : boolean = false;
  BulkRequestPermissions : boolean = false;
  BulkRequestGBS: boolean = false;
  BulkRequestApproval: boolean = false;
  RaiseRequestPermissions : boolean = false;
  ViewReportsPermissions : boolean = false;
  ApprovalDashboardPermissions : boolean = false;
  RoleIds: number[] = [];
  validAppPermissions = false;
  AEUserPermissions: boolean = false;;
  FinanceDirectorPermissions: boolean = false; ;
  FinanceManagerPermissions : boolean = false;;
  FinanceUserPermissions : boolean = false;;
  GBSCollectionPermissions : boolean = false;;
  OperationsManagerPermissions : boolean = false;;
  OperationsRegionalManagerPermissions : boolean = false;;
  PricingPermissions : boolean = false;;
  RPFBillersPermissions: boolean = false;;
  SalesSupportPermissions : boolean = false;;
  preworkPermissions: boolean = true; //false; 
  result:any;
  isLoading: boolean = false; // Add loading state for spinner

  tileStyle(styleType: StyleType, permissions: boolean): string {
    switch (styleType) {
      case 'hover':
        return permissions ? 'class="ui-tile"' : '';
      case 'unauthorized':
        return permissions ? '' : 'class="opacity-75-no-pointer"';
      case 'disabled':
        return permissions ? '' : 'class="opacity-50"';
      default:
        return '';
    }
  }

  @ViewChild(AlphaLinkbarComponent, { static: false }) child: AlphaLinkbarComponent;
  alphaComponent: AlphaLinkbarComponent;
  menuCtrl: FormControl;
  filteredmenuData: Observable<any[]>;
  @Output() outputFromChild: EventEmitter<any> = new EventEmitter();
  url: string;

  public mvr: Todo[] = [
    { title: 'Weekly Summary Report ', dateAdded: new Date().toString() },
    { title: 'Cost Center Check', dateAdded: new Date().toString() },
    { title: 'Missort Report ', dateAdded: new Date().toString() },
    { title: 'Volume Distribution', dateAdded: new Date().toString() }
  ];

  public fav: Todo[] = [

  ];

  onGoToReports(): void {

    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "reports");
  }
  onGoToApps(): void {

    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "applications");
  }


  drop(event: CdkDragDrop<Todo[]>) {

    // first check if it was moved within the same list or moved to a different list
    if (event.previousContainer === event.container) {
      // change the items index if it was moved within the same list
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

    } else {
      // remove item from the previous list and add it to the new array
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex

      );

      if (event.previousContainer.data == this.mvr) {
        Swal.fire({
          title: 'Added to Favorites!!',
          icon: 'success',
          confirmButtonText: 'OK'
        })
      }
      else {
        Swal.fire({
          title: 'Removed from favorites!!',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      }
    }
  }


  navigateModule(destination: string) {
    if (destination == 'apps') {
      localStorage.removeItem("topMenu");
      localStorage.setItem("topMenu", "applications");
      this.router.navigate(['/applications/favorites']);
    }
    else if (destination == 'admin-functions' && this.adminPermissions) {
      this.router.navigate(['admin-request'])
    }
    else if (destination == 'new-view-requests' && this.RaiseRequestPermissions) {
      localStorage.removeItem("topMenu");
      localStorage.setItem("topMenu", "viewRequest");
      this.router.navigate(['/requests/new']);
    }
    else if (destination == 'approval-dashboard' && this.ApprovalDashboardPermissions) {
        localStorage.removeItem("topMenu");
        localStorage.setItem("topMenu", "approvaldashboard");
        this.router.navigate(['/approval/approval-dashboard']);
      }
      else if (destination == 'requestStatusReport') {
        localStorage.removeItem("topMenu");
        localStorage.setItem("topMenu", "requestStatusReport");
        this.router.navigate(['/request-status-reports']);
      }
      else if (destination == 'gbs-dashboard' && (this.GBSBillingPermissions || this.GBSCollectionPermissions)) {
        localStorage.removeItem("topMenu");
        localStorage.setItem("topMenu", "gbsdashboard");
        this.router.navigate(['/gbs/gbs-dashboard']);
      }
      else if(destination=='bulk-request' && this.BulkRequestPermissions && this.BulkRequestApproval){
        this.router.navigate(['/bulk-request-approvaldashboard'])
      }
      else if(destination=='bulk-request' && this.BulkRequestPermissions && this.BulkRequestGBS){
        this.router.navigate(['/bulk-request-gbspending'])
      }
      else if(destination=='bulk-request' && this.BulkRequestPermissions){
        this.router.navigate(['bulk-request'])
      }
     

      
      
  }


  userIsAppValid = (): boolean => {
    return true;
  }

  addItem(list: string, todo: string) {
    if (list === 'todo') {
      this.mvr.push({ title: todo, dateAdded: new Date().toString() });

    } else {
      this.fav.push({ title: todo, dateAdded: new Date().toString() });
    }
  }
  constructor(private router: Router,
    private adminRequestService: AdminRequestService,
    private msalService: MsalService,
    private spinnerService: SpinnerService) {
    this.url = router.url;
  }

  ngOnInit() {
    // this.BulkRequestPermissions=true;
    this.checkUserIsAuthenticated() 
  }

 
  checkUserIsAuthenticated() {
    // Show spinner when loading user permissions
    this.isLoading = true;
    this.spinnerService.showSpinner();
    
    var jsonData = {
      CloudId:  this.msalService.instance.getActiveAccount().username.toString()
     };
     this.result = this.adminRequestService.userRoles(jsonData).subscribe({
      next: (result) => {
        var roleResponse = result;
        roleResponse.forEach(element => {
         this.RoleIds.push(element.roleId);
        });
        if(this.RoleIds.includes(UserRoleType.Admin)){
          this.adminPermissions = true;
        }        
        if(this.RoleIds.includes(UserRoleType.AE_User) || this.RoleIds.includes(UserRoleType.RPF_Billers) || this.RoleIds.includes(UserRoleType.Operations_Manager)
          || this.RoleIds.includes(UserRoleType.Sales_Support) || this.RoleIds.includes(UserRoleType.Finance_User) || this.RoleIds.includes(UserRoleType.Pricing) || this.RoleIds.includes(UserRoleType.Finance_Manager))
        {
          this.RaiseRequestPermissions = true;
        }
        if(this.RoleIds.includes(UserRoleType.Operations_Manager) || this.RoleIds.includes(UserRoleType.Operations_Regional_Manager)
        || this.RoleIds.includes(UserRoleType.Finance_Manager))
        {
          this.ApprovalDashboardPermissions= true;
        }
        if(this.RoleIds.includes(UserRoleType.Finance_Director)){
          this.ApprovalDashboardPermissions= true;
          this.BulkRequestApproval=true;
        }      
        if(this.RoleIds.includes(UserRoleType.GBS_Billing) || this.RoleIds.includes(UserRoleType.GBS_Collection) || this.RoleIds.includes(UserRoleType.District_Manager))
        {
          this.GBSBillingPermissions= true;
          this.BulkRequestGBS=true;
        }  
        if (!this.RoleIds.includes(UserRoleType.RPF_Billers) && !this.RoleIds.includes(UserRoleType.Operations_Manager) && !this.RoleIds.includes(UserRoleType.Operations_Regional_Manager))
        {
          this.BulkRequestPermissions=true;
        }

        // Hide spinner after loading completes
        this.isLoading = false;
        this.spinnerService.hideSpinner();
      },
      error: (error) => {
        console.error('Error loading user roles:', error);
        this.isLoading = false;
        this.spinnerService.hideSpinner();
      }
    });
  }
      
  }


